import React from 'react'
import { NextPage, NextPageContext } from 'next'
import { handingServerError, getHost } from 'fbk-utils'
import { HOME } from 'constants/routes'
import * as api from 'api'
import Error from 'pages/_error'
import { SiteContentProvider } from 'contexts'
import { Footer, Header, Meta } from 'components'
import { NewsData, SiteContent } from 'types'
import NewsList from './NewsList'

type PageProps =
  | {
      host: string
      newsData: NewsData
      siteContent: SiteContent
      error: null
    }
  | {
      error: {
        code: number
        message: string
      }
    }

const News: NextPage<PageProps> = props => {
  if (props.error) {
    return <Error error={props.error} />
  }

  const { newsData, siteContent, host } = props

  const goBackProps = {
    title: 'На главную',
    ...HOME,
  }

  return (
    <SiteContentProvider data={siteContent} host={host}>
      <Meta />
      <Header
        title="Все новости"
        breadcrumbs={[{ title: 'Главная', ...HOME }]}
        goBackProps={goBackProps}
      />
      <NewsList data={newsData} goBackProps={goBackProps} />
      <Footer />
    </SiteContentProvider>
  )
}

export const getServerSideProps = async (
  ctx: NextPageContext,
): Promise<{ props: PageProps }> => {
  try {
    const [siteContent, newsData] = await Promise.all([
      api.getSiteContent(),
      api.getNewsList({ limit: 8 }),
    ])

    return {
      props: {
        host: getHost(ctx),
        siteContent,
        newsData,
        error: null,
      },
    }
  } catch (err) {
    const error = handingServerError(ctx, err)

    return {
      props: {
        error,
      },
    }
  }
}

export default News
